<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  btnType: {
    type: String,
    default: 'loading',
  },
});

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm', 'play']);

const handleConfirm = () => {
  emit('confirm');
};

const handlePlay = () => {
  emit('play');
};
</script>
<template>
  <div class="main-top">
    <div class="main-up">
      <div class="logo">
        <div
          class="loading-logo"
          v-if="btnType === 'installing'">
          <div class="loader"></div>
          <img :src="info.icon" />
        </div>
        <img
          :src="info.icon"
          v-else />
      </div>
      <div class="info">
        <h1>{{ info.name }}</h1>
        <h2>{{ info.author }}</h2>
        <p>{{ info.language_list.basic_info.verified }}</p>
      </div>
    </div>
    <ul class="information">
      <li v-if="info.template_id === 5">
        <div class="ranking">
          <div class="tit">{{ info.language_list.basic_info.top_charts }}</div>
          <div>#1</div>
        </div>
      </li>
      <li>
        <strong class="flex align-center">
          {{ info.score }}&nbsp;
          <i class="iconfont icon-xingxing"></i>
        </strong>
        <p>{{ info.comment }} {{ info.language_list.basic_info.reviews }}</p>
      </li>
      <li>
        <strong>{{ info.install_num }}</strong>
        <p>{{ info.language_list.basic_info.downloads }}</p>
      </li>
      <li>
        <i class="iconfont icon-renqun"></i>

        <p v-if="info.language === 1">
          {{ info.language_list.basic_info.rated }}&nbsp;{{ info.ages }}
        </p>
        <p v-else>
          {{ info.ages }}&nbsp;{{ info.language_list.basic_info.rated }}
        </p>
      </li>
    </ul>
    <div class="info-main">
      <div class="btn-box shiny">
        <div
          id="reInstall"
          class="btn"
          v-if="btnType === 'install'"
          @click="handleConfirm">
          <div>
            <i class="iconfont icon-shandian"></i>
            {{ info.language_list.basic_info.rapid }}
          </div>
          <div class="play-btn">
            {{ info.language_list.basic_info.download }}
          </div>
        </div>
        <div
          id="installing"
          class="btn btn-h"
          v-else-if="btnType === 'installing'">
          <div id="proess"></div>
          <span id="count">0</span><span>%</span>
        </div>

        <div
          id="loading"
          class="btn btn-h"
          v-else-if="btnType === 'loading'">
          {{ info.language_list.basic_info.loading }}
        </div>
        <div
          v-else
          id="play"
          @click="handlePlay"
          class="btn btn-h">
          {{ info.language_list.basic_info.play }}
        </div>
      </div>
      <ul class="google-share-btns">
        <li @click="handleConfirm">
          <i class="iconfont icon-fenxiang1"></i>
          <span>{{ info.language_list.basic_info.share }}</span>
        </li>
        <li @click="handleConfirm">
          <svg
            class="XkAcee"
            width="24"
            height="24"
            viewBox="0 0 24 24">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z"></path>
          </svg>
          <span>{{ info.language_list.basic_info.wishlist }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-top {
  // min-height: 205px;
  margin-bottom: 20px;
  .main-up {
    display: flex;
    align-items: center;

    .info {
      h1 {
        color: #000000;
        font-weight: normal;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
      }
      h2 {
        margin-top: 5px;
        color: var(--main-color);
        font-size: 16px;
      }
      p {
        font-size: 12px;
      }
    }
  }
  .logo {
    width: 72px;
    height: 72px;
    margin-right: 24px;
    border-radius: 20%;
    img {
      display: block;
      width: 100%;
      border-radius: 20%;
      box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3),
        0 1px 3px 1px rgba(60, 64, 67, 0.15);
    }
  }
  .info-main {
    display: flex;
    width: 100%;
  }
  .information {
    display: flex;
    align-items: center;
    margin: 20px 0;
    width: 100%;
    text-align: center;
    li {
      flex: 1;
    }
    strong {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 600;
      color: #202124;
    }
    p {
      font-size: 12px;
    }
  }
  .btn-box {
    position: relative;
    overflow: hidden;
    line-height: 18px;
    width: 100%;
    margin-bottom: 20px;
  }
  .shiny:after {
    animation: shiny-btn-anim 4s ease-in-out infinite;
    background-color: #fff;
    content: '';
    display: inline-block;
    height: 100%;
    left: 0;
    position: absolute;
    top: -180px;
    width: 30px;
  }

  .google-share-btns {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--main-color);
    gap: 30px;
  }

  .google-share-btns li {
    display: flex;
    align-items: center;
    gap: 3px;
    span {
      display: inline-block;
      max-width: 180px;
    }
  }

  .google-share-btns svg {
    fill: var(--main-color);
  }
  .icon-fenxiang1 {
    font-size: 18px;
    display: inline-block;
    height: 24px;
    width: 24px;
    text-align: center;
  }
  .icon-shandian {
    color: #fff;
  }
  .play-btn {
    font-size: 10px;
  }
}
</style>
<style lang="scss">
.template-2,
.template-3,
.template-4 {
  .main-top {
    .information {
      width: 68%;
    }
  }
}
.template-4 {
  .main-top {
    .btn-box {
      width: 68%;
    }
  }
}

.template-1,
.template-5 {
  .main-top {
    .information {
      width: 100%;
      li {
        position: relative;
        flex: 1;
        text-align: center;
        &:before {
          background-color: #ddd;
          content: '';
          display: block;
          height: 12px;
          left: 0;
          position: absolute;
          top: calc(50% - 6px);
          width: 1px;
        }
      }
    }
  }
}

.template-1 {
  .main-top {
    .info-main {
      flex-direction: column;
    }
    .google-share-btns {
      flex-direction: row;
    }
    .information {
      & > :first-child:before {
        display: none;
      }
    }
  }
}
.template-2,
.template-5 {
  .main-top {
    .information {
      justify-content: space-between;
    }
    .info-main {
      flex-direction: row;
    }
    .btn {
      border-radius: 6px;
    }
    .google-share-btns {
      flex-direction: column;
      flex-basis: 1;
      width: 60%;
      align-items: flex-end;
      gap: 0;
      justify-content: flex-start;
    }
    .btn-box {
      margin-bottom: 0;
    }
  }
}

.template-3,
.template-4 {
  .main-top {
    position: relative;
    .logo {
      width: 98px;
      height: 98px;
      position: absolute;
      right: 0;
      top: 10px;
      margin-right: 0;
    }

    .info-main {
      flex-direction: column;
    }
    .google-share-btns {
      justify-content: flex-start;
    }
  }
}

.template-5 {
  .main-top {
    .google-share-btns {
      align-items: flex-start;
      margin-left: 3%;
    }
    .ranking {
      background: url(~@/assets/images/phb.png) no-repeat center center;
      width: 100%;
      color: #863300;
      .tit {
        font-weight: 600;
        font-size: 12px;
      }
    }
    .information {
      & > :last-child {
        &::after {
          background-color: #ddd;
          content: '';
          display: block;
          height: 12px;
          right: 0;
          position: absolute;
          top: calc(50% - 6px);
          width: 1px;
        }
      }
    }
  }
}
</style>
